/** @format */

import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import '../App.css';
import '../components/Movil/movil.css';
import 'bootstrap/dist/css/bootstrap.min.css';

//PAGINAS
import Sidebar from './Sidebar';
import { Estudiante } from './Estudiante';
import { Cursos } from './Cursos';
import { Horarios } from './Horario';
import { Pagos } from './Pagos';
import { HistorialAcademico } from './Historial-academico';
import { DetalleCurso } from './Detalle-curso';
import { EditarPerfil } from './Editar-perfil';
import { Login } from './Login';
import { Mfa } from './Mfa';
import { Recuperarcontraseña } from './Recuperar-contraseña';
import { RecoverPassword } from './Recover-password';
import Comoinstalar from './Movil/Comoinstalar';

//FIN PAGINAS

export default class Home extends Component {
  state = {
    isHome: true,
    isChangePasswordToken: false,
  };

  componentDidMount() {
    const valores = window.location;
    var dataUser = localStorage.getItem('userLogin');
    var dataMFA = localStorage.getItem('mfa');
    if (valores.pathname == '/') {
      window.location.href = '/login';
    } else if (valores.pathname == '/login') {
      localStorage.removeItem('userLogin');
      localStorage.removeItem('mfa');
      this.setState({
        isHome: false,
        isChangePasswordToken: false,
      });
    } else if (valores.pathname.includes('/recover-password')) {
      localStorage.removeItem('userLogin');
      localStorage.removeItem('mfa');
      this.setState({
        isHome: false,
        isChangePasswordToken: true,
      });
    } else if (valores.pathname == '/mfa') {
      if (dataUser == null || dataUser == '') {
        this.setState({
          isHome: false,
          isChangePasswordToken: false,
        });
        window.location.href = '/login';
      } else {
        if (dataMFA == null || dataMFA == '') {
          this.setState({
            isHome: false,
            isChangePasswordToken: false,
          });
        } else {
          this.setState({
            isHome: true,
            isChangePasswordToken: false,
          });
          window.location.href = '/home';
        }
      }
    } else {
      if (dataUser == null || dataUser == '') {
        this.setState({
          isHome: false,
          isChangePasswordToken: false,
        });
        window.location.href = '/login';
      } else {
        if (dataMFA == null || dataMFA == '') {
          this.setState({
            isHome: false,
            isChangePasswordToken: false,
          });
          window.location.href = '/mfa';
        }
      }
    }
  }

  render() {
    const _isMobile = this.props.isMobile;
    return (
      <Router>
        {this.state.isHome && !this.state.isChangePasswordToken ? (
          <Sidebar isMobile={_isMobile} />
        ) : null}
        <Route
          exact
          path='/login'
          component={() => {
            return <Login />;
          }}
        />
        <Route
          exact
          path='/mfa'
          component={() => {
            return <Mfa />;
          }}
        />
        <Route
          exact
          path='/recuperar-constrasenia'
          component={() => {
            return <Recuperarcontraseña />;
          }}
        />
        <Route
          exact
          path='/recover-password/:id'
          component={() => {
            return <RecoverPassword />;
          }}
        />
        <Route
          exact
          path='/home'
          component={() => {
            return <Estudiante />;
          }}
        />
        <Route
          exact
          path='/curso'
          component={() => {
            return <Cursos />;
          }}
        />
        <Route
          exact
          path='/detalle-curso/:courseId/:courseSection/:period'
          component={() => {
            return <DetalleCurso />;
          }}
        />
        <Route
          exact
          path='/horarios'
          component={() => {
            return <Horarios />;
          }}
        />
        <Route
          exact
          path='/pagos'
          component={() => {
            return <Pagos />;
          }}
        />
        <Route
          exact
          path='/historial-academico'
          component={() => {
            return <HistorialAcademico />;
          }}
        />
        <Route
          exact
          path='/editar-perfil'
          component={() => {
            return <EditarPerfil />;
          }}
        />
        <Route exact path='/como-instalar' component={Comoinstalar} />
      </Router>
    );
  }
}
